import { useQuery } from "@tanstack/react-query";
import { useContext } from "react";
import { WishlistRepositoryImpl } from "../../domain/wishlistRepositoryImpl/WishlistRepositoryImpl";
import { queryClientContext } from "../hooks/useQueryClient";
import { useStaticInfo } from "../hooks/useStaticInfo";
import { DEFAULT_CURRENCY } from "../shared/config";

const wishlistRepo = WishlistRepositoryImpl.getInstance();

const useGetCurrencyAndProductVariants = () => {
  const {
    session: { auth },
    apiUrl,
  } = useStaticInfo();

  const queryClient = useContext(queryClientContext);

  const { isLoading, data, refetch } = useQuery(
    {
      queryKey: ["currencyAndProductsVariants", auth],
      queryFn: async () => {
        return await wishlistRepo.getCurrencyAndProductVariants(auth, apiUrl);
      },
      enabled: Boolean(auth),
    },
    queryClient,
  );

  return {
    isLoading,
    currency: data ? data.currency : DEFAULT_CURRENCY,
    productVariants: data ? data.productVariants : [],
    refetch,
  };
};

export { useGetCurrencyAndProductVariants };
